import type { DisciplineStore } from '@stores/discipline/interfaces'

export const createInitialState = (): DisciplineStore => ({
  activeCode: null,
  pendingLanding: null,
  mathLanding: false,
  elaLanding: false,
  infoById: {},
  modalTutorProfile: false,
  disciplineScheduleShow: true, // TODO: FEATURE FLAG for Schedule
})
